import { View } from '@react-pdf/renderer'
import FormPdfFillArea from '../../pdf-components/FormPdfFillArea'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

const FormNumericInputFillablePdf = (typeProps, langVersion, ...props) => {
  const style = {
    fontSize: pdfDefaultFontSize,
    padding: 6
  }

  return (
    <View style={style}>
      <FormPdfFillArea lines={1} />
    </View>
  )
}

export default FormNumericInputFillablePdf
